'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import CreditCardController from './credit-card.controller';
import CreditCardService from '../../../credit-card-list/credit-card.service';
import AddressForm from '../address';
import AddressService from '../address/address.service';
export default angular.module('directives.creditCardForm', [ngMaterial, AddressForm, 'angularPayments'])
    .service('CreditCardService', CreditCardService)
    .service('AddressService', AddressService)
    .controller('CreditCardController', CreditCardController)
    .component('creditCardForm', {
    template: require('./credit-card.html'),
    controller: CreditCardController,
    bindings: {
        creditCard: '<',
        updateForm: '<',
        createForm: '<',
        addresses: '<',
        isDefault: '<',
        showAlert: '=',
        isCardExpired: '=',
        onCardValidation: '&?'
    }
})
    .name;
//# sourceMappingURL=index.js.map